<app-main-toolbar (toogleSideNav)="openSideNav($event)"></app-main-toolbar>

<mat-sidenav-container (backdropClick)="close()" class="main-sidenav-container" [hasBackdrop]="true" style="z-index: 3;">
    <mat-sidenav #sidenav (keydown.escape)="close()" [fixedInViewport]="true" position="end">
        <app-sidenav></app-sidenav>
    </mat-sidenav>
    <mat-sidenav-content fxLayout="column" fxFill>
        <router-outlet></router-outlet>
    </mat-sidenav-content>
</mat-sidenav-container>